module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('div', {
    staticClass: "button-row primary-row"
  }, [_c('div', {
    staticClass: "keyboard-dpad"
  }, [_c('div', {
    staticClass: "dpad-top"
  }, [_c('vbutton', {
    ref: "dom_left",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelLeft,
      "active": _vm.keyboard['left']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_right",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelRight,
      "active": _vm.keyboard['right']
    }
  })], 1), _vm._v(" "), _c('vbutton', {
    ref: "dom_down",
    staticClass: "dpad-down",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelDown,
      "active": _vm.keyboard['down']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "keyboard-action"
  }, [_c('vbutton', {
    ref: "dom_rotate",
    staticClass: "action-rotate",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.rotation,
      "active": _vm.keyboard['rotate']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_space",
    staticClass: "action-drop",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelDropSpace,
      "active": _vm.keyboard['drop']
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40bc7dd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/index.vue
// module id = 171
// module chunks = 1